var map = {
	"./ca_ES": [
		"./src/lang/ca_ES.json",
		"lang0"
	],
	"./ca_ES.json": [
		"./src/lang/ca_ES.json",
		"lang0"
	],
	"./es_ES": [
		"./src/lang/es_ES.json",
		"lang2"
	],
	"./es_ES.json": [
		"./src/lang/es_ES.json",
		"lang2"
	],
	"./pt_PT": [
		"./src/lang/pt_PT.json",
		"lang4"
	],
	"./pt_PT.json": [
		"./src/lang/pt_PT.json",
		"lang4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/lang lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;